// The Account page's Login Accounts tab (laravel App\LoginAccounts): the account's one admin and its district managers.

// The header's Change Password form opens on this event (layouts/layout-components/header/header.js)
export const OPEN_CHANGE_PASSWORD_EVENT = 'mobiliis:open-change-password';

export const NOT_RECORDED = 'Not yet recorded';
export const NO_DISTRICT_MANAGERS = 'No district managers yet.';
export const DISTRICT_MANAGERS_NOTE = 'District managers can only see their own district and cannot change account settings.';

// "15 Nov 2026, 09:30" in the browser's time zone (or timeZone), from the server's UTC time; "Not yet recorded"
export function signInText(iso, timeZone) {
	if (!iso) {
		return NOT_RECORDED;
	}
	const date = new Date(iso);
	if (isNaN(date.getTime())) {
		return NOT_RECORDED;
	}
	const options = { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false };
	if (timeZone) {
		options.timeZone = timeZone;
	}
	return new Intl.DateTimeFormat('en-GB', options).format(date);
}

// Only the account admin changes the account admin's password: not the super admin looking at the account, whose own
// password the form would change
export function canChangePassword(level, mainAdminLevel) {
	return level === 'c' && mainAdminLevel !== 'a';
}

export function openChangePassword() {
	window.dispatchEvent(new Event(OPEN_CHANGE_PASSWORD_EVENT));
}
